import axios from "axios";

const fetchLogs = (params, config) => {
  return axios.get(`/api/v1/logs`, {
    params,
    ...config,
  });
};

const ApiLogs = {
  fetchLogs,
};

export default ApiLogs;
